import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/leaderboard-up.svg'
import _imports_1 from '@/assets/img/Icons/leaderboard-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-e03f6bd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar-title" }
const _hoisted_2 = {
  key: 0,
  class: "avatar"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "group-name" }
const _hoisted_5 = {
  key: 0,
  class: "title-rank"
}
const _hoisted_6 = { class: "response-nps" }
const _hoisted_7 = { class: "response" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "total-response-tooltip-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Team Scoreboard only shows surveys which measure frontline performance with a Scorecard question. As a result it may be different to your AskNicely dashboard which measures performance from all your surveys. ")
], -1))
const _hoisted_10 = { class: "number" }
const _hoisted_11 = { class: "nps-block" }
const _hoisted_12 = { class: "nps" }
const _hoisted_13 = {
  key: 0,
  class: "change"
}
const _hoisted_14 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_15 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_16 = { class: "number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextClamp = _resolveComponent("TextClamp")!
  const _component_NPSTooltip = _resolveComponent("NPSTooltip")!
  const _component_FormattedNumber = _resolveComponent("FormattedNumber")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["brief-info", { 'has-rank': _ctx.showRank }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.tsCurrentGroupAvatar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.avatarUrl,
              alt: "avatar",
              class: "avatar-img"
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TextClamp, {
            text: _ctx.tsCurrentGroupTitle,
            "max-lines": 1
          }, null, 8, ["text"])
        ]),
        (_ctx.tsNpsSummary.rank)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.tsNpsSummary.rank) + _toDisplayString(_ctx.getOrdinalRank(_ctx.tsNpsSummary.rank)) + " within " + _toDisplayString(_ctx.tsNpsSummary.rankFieldLabel), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(" TOTAL RESPONSES "),
          (
                            !_ctx.isMobile && !_ctx.previousTeamScoreboard && !_ctx.hideTooltip
                        )
            ? (_openBlock(), _createBlock(_component_NPSTooltip, {
                key: 0,
                width: 240,
                color: "#93A1BE"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_FormattedNumber, {
            number: _ctx.tsNpsSummary.total
          }, null, 8, ["number"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getNpsRounded(_ctx.tsNpsSummary.nps)) + _toDisplayString(_ctx.csatInPercentage ? '%' : ''), 1),
        (!_ctx.tsNpsSummary.isFiveScore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.tsNpsSummary.change >= 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                : (_openBlock(), _createElementBlock("img", _hoisted_15)),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getNpsRounded(_ctx.tsNpsSummary.change)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (!!_ctx.tsLoadingNpsSummary)
      ? (_openBlock(), _createBlock(_component_Loading, {
          key: 0,
          loading: ""
        }))
      : _createCommentVNode("", true)
  ], 2))
}